import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { Preview } from "@creatomate/preview";
import { Loader } from "@culturehq/components";

import { Organization, Profile, Template as Templates } from "chq";
import { useProfile } from "app/context";
import { isAdmin } from "app/permissions";
import { Trans } from "app/utils";
import { aspectRatioMap } from "app/utils/constants";

import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import setTemplate from "components/stories/video-studio/utils/creatomate/setTemplate";

import ImageCard from "./image-card/ImageCard";

interface ImageTemplatesProps {
  preview: Preview;
  templates: Templates[];
}

const ImageTemplates: React.FC<ImageTemplatesProps> = ({ preview, templates }) => {
  const { data, handleUpdateData } = useContext(CreatomateContext);
  const { mediaType, selectedTemplate, story } = data;

  const { profile } = useProfile();

  const getAspectRatio = (template: Templates): string => {
    const key = `${template.width}x${template.height}`;
    return aspectRatioMap[key] || "wide-landscape";
  };

  const handleSelectedTemplate = (template: Templates) => {
    handleUpdateData({
      aspectRatioStringValue: getAspectRatio(template),
      selectedTemplate: template
    });
    getAspectRatio(template);
    setTemplate(
      "image",
      preview,
      profile.organization as Organization,
      mediaType,
      template,
      story
    );
  };

  if (!templates) return <Loader loading />;

  if (templates.length === 0) {
    if (isAdmin(profile as Profile)) {
      return (
        <div className="Stories-Templates__empty">
          <p>
            <Trans>No templates found</Trans>
          </p>
          <p className="Stories-Templates__empty">
            <Trans>You can go to the</Trans>
            {" "}
            <Link to="/admin/templates">
              Templates
            </Link>
            {" "}
            <Trans>
              in the Admin section and select or create a new Template for Images
            </Trans>
          </p>
        </div>
      );
    }

    return (
      <div className="Stories-Templates__empty">
        <Trans>No templates found</Trans>
      </div>
    );
  }

  return (
    <>
      {templates.map(template => (
        <ImageCard
          key={template.value}
          template={template}
          onSelectedTemplate={handleSelectedTemplate}
        />
      ))}
    </>
  );
};

export default ImageTemplates;
